import axios from "axios"

export const dataArys = (productId, docId, isBranded, isServiceScore, cb) => {

    let dataAry = []
    const url = "/marketplace/dc-common/scoreDetail.ns"
    const queryParams = `pid=${productId}&docid=${docId}`
    axios.get(`${url}?${queryParams}`).then(rsp => {
        const res = rsp.data
        if (res?.error == 0) {
            const finalWeightData = res?.results
            const wordWeight = finalWeightData?.pname_det?.calc?.weight?.word_weight || 0
            const specWeight = finalWeightData?.pname_det?.calc?.weight?.spec_weight || 0
            const imageWeight = finalWeightData?.image_det?.calc?.weight?.image_weight || 0
            const firstImg = imageWeight >= 10 ? 10 : 0
            const secondImg = imageWeight >= 20 ? 10 : 0
            const thirdImg = imageWeight >= 30 ? 10 : 0
            const priceWeight = finalWeightData?.price_det?.calc?.weight?.price_weight || 0
            const dlengthWeight = finalWeightData?.desc_det?.calc?.weight?.dlength_weight || 0
            const spexWeight = finalWeightData?.spec_det?.calc?.weight?.spec_count_weight || 0 
            const threeSpec = spexWeight >= 10 ? 10 : 0
            const fourSpec = spexWeight >= 15 ? 5 : 0
            const fiveSpec = spexWeight >= 20 ? 5 : 0

            const wordWeightAge = finalWeightData?.pname_det?.calc?.measure_weightage?.word_weightage || 0
            const specWeightAge = finalWeightData?.pname_det?.calc?.measure_weightage?.spec_weightage || 0
            const imageweightAge = finalWeightData?.image_det?.calc?.measure_weightage?.image_weightage || 0
            const firstImgAge = imageweightAge >= 10 ? 10 : 0
            const secondImgAge = imageweightAge >= 20 ? 10 : 0
            const thirdImgAge = imageweightAge >= 30 ? 10 : 0
            
            const priceWeightAge = finalWeightData?.price_det?.calc?.measure_weightage?.price_weightage || 0
            const dlengthWeightAge = finalWeightData?.desc_det?.calc?.measure_weightage?.dlength_weightage || 0
            const specweightAge = finalWeightData?.spec_det?.calc?.measure_weightage?.spec_count_weightage || 0
            const threeSpecAge = specweightAge >= 10 ? 10 : 0
            const fourSpecAge = specweightAge >= 15 ? 5 : 0
            const fiveSpecAge = specweightAge >= 20 ? 5 : 0

            const nameAry = [{ key: "3 or more Words", value: wordWeight, exp: wordWeightAge }]
            const imgAry = [{ key: "1 Photo", value: firstImg, exp: firstImgAge }]
            const priceAry = [{ key: "Price", value: priceWeight, exp: priceWeightAge }]
            let specsAry = [{ key: "3 Specifications added", value: threeSpec, exp: threeSpecAge }, { key: "4 Specifications added", value: fourSpec, exp: fourSpecAge }, { key: "5 or more Specifications added", value: fiveSpec, exp: fiveSpecAge }]
            if (isBranded) {
                dataAry = [{
                    key: "", valAry: [
                        { key: "Product Name", value: Number(wordWeight) + Number(specWeight), exp: Number(wordWeightAge) + Number(specWeightAge) },
                        { key: "Photos", value: imageWeight, exp: imageweightAge},
                        { key: "Price", value: priceWeight, exp: priceWeightAge },
                        { key: "Description (100+ Characters)", value: dlengthWeight, exp: dlengthWeightAge },
                        { key: "Specifications", value: spexWeight, exp: specweightAge },
                        { key: "Total", value: 0, exp: 100 }
                    ]
                }]
            } else {
                if (isServiceScore) {
                    imgAry.push({ key: "2 or more Photos", value: secondImg, exp: secondImgAge })
                    specsAry = [{ key: "2 Specifications added", value: threeSpec, exp: threeSpecAge }, { key: "3 Specifications added", value: fourSpec, exp: fourSpecAge }, { key: "4 or more Specifications added", value: fiveSpec, exp: fiveSpecAge }]
                } else {
                    nameAry.push({ key: "At least 1 Specification", value: specWeight, exp: specWeightAge })
                    imgAry.push({ key: "2 Photos", value: secondImg, exp: secondImgAge })
                    imgAry.push({ key: "3 or more Photos", value: thirdImg, exp: thirdImgAge })
                    priceAry.push({ key: "Description (100+ Characters)", value: dlengthWeight, exp: dlengthWeightAge })
                }

                dataAry = [
                    { key: `${isServiceScore ? "Service" : "Product"} Name`, valAry: nameAry },
                    { key: "Photos", valAry: imgAry },
                    { key: "", valAry: priceAry },
                    { key: "Specifications", valAry: specsAry },
                    { key: "", valAry: [{ key: "Total", value: 0, exp: 100 }] }
                ]
                if (isServiceScore) {
                    const desc200 = dlengthWeight >= 15 ? 15 : 0
                    const desc500 = dlengthWeight >= 25 ? 10 : 0
                    const desc200weightAge = dlengthWeightAge >= 15 ? 15 : 0 
                    const desc500weightAge = dlengthWeightAge >= 25 ? 10 : 0
                    const descAry = [{ key: "At least 200 characters", value: desc200, exp: desc200weightAge }, { key: "500 or more characters", value: desc500, exp: desc500weightAge }]
                    const descObj = { key: "Description", valAry: descAry }
                    dataAry.splice(3, 0, descObj)
                }
            }
            cb(dataAry)
        } else {
            cb([], res?.msg || "Something went wrong")
        }
    }).catch(err => {
        console.log("Error is ", err);
        cb([], err.message || "Something went wrong")
    })
}

export const classCodeCss = (totalScore = 0) => {

    let scoreColorCode = '#000000';
    let scoreSchmeClass = '';


    if (totalScore >= 0 && totalScore < 19) {
        scoreColorCode = "#b30104";
        scoreSchmeClass = 'product-score-red';
    } else if (totalScore >= 20 && totalScore < 39) {
        scoreColorCode = "#c62b01";
        scoreSchmeClass = 'product-score-orange';
    } else if (totalScore >= 40 && totalScore < 59) {
        scoreColorCode = "#B24800";
        scoreSchmeClass = 'product-score-yellow';
    } else if (totalScore >= 60 && totalScore < 79) {
        scoreColorCode = "#163200";
        scoreSchmeClass = 'product-score-light-green';
    } else if (totalScore >= 80 && totalScore <= 100) {
        scoreColorCode = "#005517";
        scoreSchmeClass = 'product-score-green';
    }

    return { scoreColorCode, scoreSchmeClass }
}